<template>
    <div class="common">
        <search-form
        :formConfig="formConfig"
        :source="searchData"
        @search="search"
        >
            <template slot="btns">
                <a-button @click="createFun()" class="search-btn-item btn-blue-line">新增</a-button>
                <a-button @click="editFun()" class="search-btn-item btn-blue-line" :disabled="!selectedRowKeys.length">修改</a-button>
                <a-button @click="setPwdFun()" class="search-btn-item btn-blue-line" :disabled="!selectedRowKeys.length">重置密码</a-button>
            </template>
        </search-form>

        <div class="table-common">
            <a-table
                size="middle"
                :columns="columns"
                :data-source="tableData"
                :pagination="pagination"
                :loading="loading"
                :row-key="(record,index) => record.id+'_'+index"
                @change="handleTableChange"
                bordered
                :locale="{emptyText: '暂无数据'}"
                :row-selection="tableSelect"
            >
                <template slot="createTime" slot-scope="text">{{text | dateFormat('YYYY-mm-dd')}}</template>
                <template slot="isEnable" slot-scope="text">{{text==1?"启用":"停用"}}</template>
                <template slot="operation" slot-scope="text, record">
                    <a @click="toPageDetail(record)">详情</a>
                </template>
            </a-table>
            <div :class="{'table-total':pagination.total>0,'table-total-none':pagination.total==0}">
                共有记录：
                <span class="text-color-blue">{{pagination.total}} 条</span>
            </div>
        </div>
<!-- :bodyStyle="{maxHeight:'570px',overflow:'auto'}" -->
        <a-modal
        width="70%"
        :title="modalTitle"
        cancelText="取消"
        okText="确定"
        :visible="modalShow"
        :maskClosable="false"
        @cancel="modalShow=false;"
        @ok="modalOk"
        :confirm-loading="confirmLoading"
        :cancelButtonProps="cancelButtonProps"
        :okButtonProps="cancelButtonProps"
        dialogClass="dialogBig"
        :destroyOnClose="true"
        >
            <template slot="footer" v-if="modalData.type=='detail'">
                <a-button type="primary" @click.stop="()=>{modalShow=false}">取消</a-button>
            </template>
            <user-create-modal ref="userMsgModal" :modalData="modalData" :parentObj="parentObj"></user-create-modal>
        </a-modal>
    </div>
</template>

<script>
import {userPageApi,roleApi,resetApi} from "@/api/role.js"
import userCreateModal from "@/pages/system/user/user-create-modal"
export default {
    name:"userMain",
    components: {userCreateModal},
    data() {
        return {
            searchData:{
                loginName:"",
                userName:"",
                idCardNum:"",
                department:"",
                mobile:"",
                roleCode:"",
                isEnable:""
            },
            formConfig:[
                {
                    prop: "loginName",
                    type: "input",
                    label: "登录名",
                },
                {
                    prop: "userName",
                    type: "input",
                    label: "姓名",
                },
                {
                    prop: "idCardNum",
                    type: "input",
                    label: "身份证号",
                },
                {
                    prop: "department",
                    type: "input",
                    label: "部门",
                },
                {
                    prop: "mobile",
                    type: "input",
                    label: "手机号码",
                },
                {
                    prop: "roleCode",
                    type: "select",
                    label: "用户角色",
                    option: [],
                    defaultProps: {
                        value: "roleCode",
                        label: "roleName"
                    }
                },
                {
                    prop: "isEnable",
                    type: "select",
                    label: "状态",
                    option: [
                        {key: '1', text: '启用'},
                        {key: '2', text: '停用'},
                    ],
                    defaultProps: {
                        value: "key",
                        label: "text"
                    }
                },
            ],
            columns: [
                {
                    title:"登录名",
                    width:"100px",
                    dataIndex: "loginName"
                },
                {
                    title: "姓名",

                    dataIndex: "userName"
                },
                {
                    title: "身份证号	",
                    dataIndex: "idCardNum",
                    width:"140px"
                },
                {
                    title: "部门",
                    dataIndex: "department"
                },
                {
                    title: "手机号码",
                    dataIndex: "mobile",
                    width:"100px"
                },
                {
                    title: "用户角色",
                    dataIndex: "roleName",
                    width:"120px"
                },
                {
                    title: "创建日期",
                    dataIndex: "createTime",
                    scopedSlots: { customRender: "createTime" },
                },
                {
                    title: "状态",
                    dataIndex: "isEnable",
                    scopedSlots: { customRender: "isEnable" },
                },
                {
                    title: "操作",
                    dataIndex: "operation",
                    scopedSlots: { customRender: "operation" },
                }
            ],
            tableData: [],
            pagination: {
                pageSize: 10,
                current: 1,
                sortField: "",
                sortOrder: "",
                total: 0,
            },
            loading: false,
            selectedRows: [],
            selectedRowKeys:[],
            modalTitle:"新增用户",
            modalShow:false,
            confirmLoading:false,
            modalData:{},
            cancelButtonProps:{
                props:{
                    shape:"round"
                }
            },
            parentObj:this,
            footerShow:true

        };
    },
    computed: {
        tableSelect(){
            return {
                selectedRowKeys: this.selectedRowKeys,
                selectedRows: this.selectedRows,
                onChange: this.onTableChange,
                type:"radio"
            }
        },
    },
    created() {
        this.getRole();
        this.getTableData();
    },
    methods: {
        getRole(){
            roleApi()
            .then(res => {
                const index = this.formConfig.findIndex(item => item.prop == "roleCode");
                this.formConfig[index].option = res.data;
            })
            .catch(err => {
                console.log(err);
            })
        },
        search(data){
            this.searchData = data || this.searchData;
            this.getTableData();
        },
        getTableData(){
            this.loading = true;
            const param = {
                loginName: this.searchData.loginName,
                userName: this.searchData.userName,
                idCardNum: this.searchData.idCardNum,
                department: this.searchData.department,
                mobile: this.searchData.mobile,
                roleCode: this.searchData.roleCode,
                isEnable: this.searchData.isEnable,
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize,
            }
            userPageApi(param)
            .then((res)=>{
                this.loading = false;
                this.pagination.total = res.data.grid.total;
                this.tableData = res.data.grid.list;
            })
            .catch(err => {
                this.loading = false;
                console.log(err);
            })
        },
        handleTableChange(pagination, filters, sorter) { //表格排序回调
            this.pagination = {
                current: pagination.current,
                pageSize: pagination.pageSize,
                sortField: sorter.field,
                sortOrder: sorter.order,
                total: this.pagination.total || 0,
            };
            this.getTableData();
        },
        onTableChange(selectedRows, data, data2) { //表格选择回调
            this.selectedRowKeys = selectedRows;
            this.selectedRows = data;
        },
        toPageDetail(data){
            this.modalData = {
                type:"detail",
                data:data
            };
            this.modalTitle = "用户详情";
            this.modalShowFun();
        },
        createFun(){
            this.modalData = {
                type:"create"
            };
            this.modalTitle = "新增用户";
            this.modalShowFun();
        },
        editFun(){
            this.modalData = {
                type:"edit",
                data:this.selectedRows[0]
            };
            this.modalTitle = "修改用户信息";
            this.modalShowFun();
        },
        setPwdFun(){
            if(this.selectedRows.length == 0){
                this.$message.warn("请至少选择一条数据");
                return;
            }
            let self = this;
            this.$confirm({
                title:"重置密码",
                content:`确定要重置"${this.selectedRows[0].loginName}"的登录密码么?`,
                okText:"确认",
                cancelText:"取消",
                onOk() {
                    const param = {
                        id: self.selectedRows[0].id,
                        loginName: self.selectedRows[0].loginName,
                        password: self.utils.getPasswordEncryptString(self.randomWord(false, 8))
                    }
                    resetApi(param)
                    .then(res => {
                        self.$message.success("新的登录密码已发送至用户密保手机");
                        self.refresh();
                    })
                    .catch(err => {
                        self.refresh();
                        console.log(err);
                    })

                },
                onCancel() {
                    self.refresh();
                }
            })

        },
        randomWord(randomFlag, min, max = null) {
            let str = '',
            range = min,
            // tslint:disable-next-line:prefer-const
            arr = [
                '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
                'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j',
                'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
                'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D',
                'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N',
                'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X',
                'Y', 'Z'
            ];

            // 随机产生
            if (randomFlag) {
            range = Math.round(Math.random() * (max - min)) + min;
            }
            for (let i = 0; i < range; i++) {
            const pos = Math.round(Math.random() * (arr.length - 1));
            str += arr[pos];
            }
            return str;
        },
        modalShowFun(data){
            this.modalShow = true;
        },
        modalOk(){
            this.$refs.userMsgModal.modalOk()
        },
        modalCancel(){
            this.modalShow = false;
        },
        refresh(){
            this.modalCancel();
            this.selectedRows = [];
            this.selectedRowKeys = [];
            this.getTableData();
        }
    },
    activated() {},
    watch: {}
};
</script>
<style scoped>
.table-common /deep/ .ant-table-selection-column{
    width: 40px!important;
    padding: 0!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/user/user-main.vue